import React, { memo, useCallback, useMemo } from "react";
import cls from "classnames";
import dayjs from "dayjs";
import { useT, useCtx, withRedux, WithReduxHocPropsType } from "@al/next/al-ex";
import { LazyImage } from "@al/akui-mobile";
import { PriceTools, CountryCode } from "@al/base-lib";

import LineThroughPrice from "~/components/ui/LineThroughPrice";

import ProductCountDown from "../../components/ProductCountDown";
import { SkuPriceType, ActivityType, PromotionGuideBarType } from "../../types";

import styles from "./styles.scss";
import { getImages } from "./constant";

interface Props extends WithReduxHocPropsType {
  skuPrice: SkuPriceType | null;
}

// 两个活动，秒杀活动最大倒计时24小时，直降活动最大倒计时为72小时
function getEndTime(type: ActivityType, endTime: number): number {
  const baseNum = type === ActivityType.FlashSale ? 1 : 3;
  if (dayjs(Number(endTime)).diff(dayjs(), "day", true) > baseNum) {
    return dayjs().add(baseNum, "day").valueOf();
  }
  return Number(endTime) || endTime;
}

const Promotion: React.FC<Props> = (props) => {
  const t = useT();
  const ctx = useCtx();
  const { promotion, couponPrice, sellingPrice } = props.skuPrice || {};
  const isFlashSale = promotion?.activityType === ActivityType.FlashSale;

  const promotionImage = useMemo(() => getImages(isFlashSale ? "flash" : "limited"), [isFlashSale]);

  const onTimeOver = useCallback(() => {
    // 刷新当前页
    window.location.replace(location.href);
  }, []);

  // 无活动或者活动引导样式为 4 的时候不显示
  if (!promotion || promotion.guideBarStyle === PromotionGuideBarType.None) return null;

  // 秒杀最大倒计时24小时 直降最大倒计时为72小时
  const endTime = getEndTime(promotion?.activityType, promotion.endTime);

  return (
    <LazyImage
      className={styles.promotion}
      closeLazy
      mode="noPreOrFail"
      src={promotion.guideBarImage || promotionImage.bg}
      width="3.6rem"
      height="0.6rem"
    >
      <div className={styles.left}>
        <div className={styles.promotion_price_box}>
          <span className={styles.promotion_price}>
            {PriceTools.formatPrice(ctx.locale.countryCode as CountryCode, couponPrice || sellingPrice, "price")}
          </span>
          {couponPrice && <span className={styles.promotion_price_text}>{t("券后价")}</span>}
        </div>
        {promotion.discount || promotion.crossedPrice ? (
          <div className={styles.promotion_origin_price_box}>
            {promotion.crossedPrice && (
              <LineThroughPrice className={styles.promotion_origin_price} value={promotion.crossedPrice || 0} />
            )}
            {promotion.discount && <span className={styles.promotion_discount}>-{promotion.discount}</span>}
          </div>
        ) : null}
      </div>
      <div className={styles.right}>
        <div className={cls(styles.promotion_name, { [styles.limited_offer_nam]: !isFlashSale })}>
          {isFlashSale ? t("秒杀") : t("限时折扣")}
        </div>
        <div className={styles.promotion_time}>
          <ProductCountDown endTime={endTime} onTimeOver={onTimeOver} />
        </div>
      </div>
    </LazyImage>
  );
};

export default withRedux((state) => ({ skuPrice: state.static.skuPrice }))(memo<Props>(Promotion));
